<template>
  <div>
    <b-form-group :label="title" label-for="filter">
      <div class="d-flex align-items-center">
        <b-form-input
          id="filter1"
          type="date"
          v-model="localStart"
          class="d-inline-block mr-2"
        ></b-form-input>
        <span class="mx-2">a</span>
        <b-form-input
          id="filter2"
          type="date"
          v-model="localEnd"
          class="d-inline-block"
        ></b-form-input>
      </div>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "DataRangeFilter",
  props: {
    title: {
      type: String,
      required: true
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    defaultDate: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      initialStartDate: this.defaultDate ? this.getFirstDayOfMonth() : "",
      initialEndDate: this.defaultDate ? this.getLastDayOfMonth() : ""
    };
  },
  computed: {
    localStart: {
      get() {
        return this.startDate || this.initialStartDate;
      },
      set(newValue) {
        this.$emit("update:startDate", newValue);
        this.emitFilter();
      }
    },
    localEnd: {
      get() {
        return this.endDate || this.initialEndDate;
      },
      set(newValue) {
        this.$emit("update:endDate", newValue);
        this.emitFilter();
      }
    }
  },
  methods: {
    emitFilter() {
      this.$emit("filter-changed", {
        startDate: this.localStart,
        endDate: this.localEnd
      });
    },
    getFirstDayOfMonth() {
      const date = new Date();
      return `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-01`;
    },
    getLastDayOfMonth() {
      const date = new Date();
      const lastDay = new Date(
        date.getFullYear(),
        date.getMonth() + 1,
        0
      ).getDate();
      return `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${lastDay}`;
    }
  },
  created() {
    if (!this.startDate && !this.endDate) {
      this.localStart = this.initialStartDate;
      this.localEnd = this.initialEndDate;
    }
  }
};
</script>
